module.exports = __webpack_public_path__ + "static/media/yycOrdered.e5e9bb8b.png";